import React from 'react';

import {FilterInput} from 'src/components/input';
import {useUserLayouts} from 'src/modules/profile/user/tabs/content/layouts/hooks/useUserLayouts';
import {LayoutTable} from 'src/modules/profile/user/tabs/content/layouts/layout-table';
import {SCOPE_KEY, SEARCH_INPUT_WIDTH} from 'src/modules/profile/user/tabs/content/layouts/util';

import {BoxLoading} from '@pb/kit-component-box-loading';
import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';
import Typography from '@pb/kit-component-typography';

import {ContentTabs} from '../content-tabs';
import {container, panel} from '../content.module.styl';

type Props = {
    userId: number,
};

export const Layouts = ({userId}: Props) => {
    const {data, criteria, isFetching, setCriteria, setPage, setPageSize, total} = useUserLayouts({
        scopeKey: SCOPE_KEY,
        userId,
    });

    const hasActiveFilters = !!criteria?.searchByName || !!criteria?.layoutType || !!criteria?.entityTypes?.length;
    const isNoCreatedLayouts = !hasActiveFilters && total === 0;

    return (
        <>
            <StickyElement id="sticky-element">
                <ContentTabs userId={userId} activeTab="layouts"/>
                <Group direction="h" gap="xxl" className={panel}>
                    <Typography fontWeight="semi-bold" variant="heading-level-3">
                        Layouts
                    </Typography>
                    <FilterInput
                        id="user-layout-name-filter"
                        placeholder="Search for layouts by name"
                        onChange={query => setCriteria({searchByName: query})}
                        onClear={() => setCriteria({searchByName: undefined})}
                        timeOut={1000}
                        disabled={isNoCreatedLayouts}
                        width={SEARCH_INPUT_WIDTH}
                        maxLength={50}
                        value={criteria?.searchByName || ''}
                    />
                </Group>
            </StickyElement>
            <BoxLoading loading={isFetching}>
                <Group direction="v" className={container}>
                    <LayoutTable
                        data={data}
                        total={total}
                        setPage={setPage}
                        setPageSize={setPageSize}
                        criteria={criteria}
                        isNoCreatedLayouts={isNoCreatedLayouts}
                    />
                </Group>
            </BoxLoading>
        </>
    );
};
